import {
  AfterViewInit,
  Component,
  Inject,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { FormControl } from "@angular/forms";
// import {MD_DIALOG_DATA} from '@angular/material';
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { UiService } from "app/helper-components/UiService";
import { MULTIPLE_SELECTION, SINGLE_SELECTION } from "app/helpers/Constants";
import { HelperService } from "app/helpers/helper.service";
import { PostService } from "app/helpers/post.service";
import { environment } from "environments/environment";
import { Observable, Subscription } from "rxjs";

export interface Food {
  value: string;
  viewValue: string;
  img: string;
}
@Component({
  selector: "app-add_booth",
  templateUrl: "./add_booth.component.html",
  styleUrls: ["./add_booth.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AddBoothComponent implements OnInit, AfterViewInit {
  myControl = new FormControl();
  boothList: [];
  parameters: any;
  dialogData: any;
  subscription: Subscription;
  boothFormArray: Array<any> = [];
  booth: any;
  booth_number: number;
  selectedBoothIds: any = [];
  filterBooths: any = [];
  filteredOptions: Observable<string[]>;
  dataLoaded = false;

  config = {
    selection_type: MULTIPLE_SELECTION,
    hide_have_branch: false,
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialog_param: any,
    public matDialogRef: MatDialogRef<AddBoothComponent>,

    private uiService: UiService,
    private _activatedRoute: ActivatedRoute,
    private helper: HelperService,
    private dialogRef: MatDialogRef<AddBoothComponent>,
    private postService: PostService,
    private translate: TranslateService,
    private matSnackBar: MatSnackBar
  ) {
    this.dialogData = dialog_param;
    this.selectedBoothIds = this.dialogData.selectedBoothIds;
    this.parameters = this.dialogData.parameters;
    this.config = { ...this.config, ...this.dialogData.config };
  }

  ngOnInit() {}

  ngAfterViewInit(): void {
    const formData = new FormData();

    formData.append("getBoothsByConstituency", "1");
    formData.append("const_id", this.parameters.const_id);

    this.postService.post(environment.API_BOOTHS, formData).subscribe((val) => {
      this.dataLoaded = true;
      this.boothList = val.data;
      this.filterBooths = [...this.boothList];

      this.filterBooths.sort((a: any, b: any) => {
        if (this.selectedBoothIds.includes(b.booth_id)) {
          b.checked = true;
          return 1;
        } else if (this.selectedBoothIds.includes(a.booth_id)) {
          a.checked = true;
          return -1;
        }

        return 0;
      });
    });
  }

  boothSelected(status, booth) {
    booth.checked = status;
    if (status == true) {
      if (!this.selectedBoothIds.includes(booth.booth_id)) {
        this.selectedBoothIds.push(booth.booth_id);
      }
    } else {
      if (this.selectedBoothIds.includes(booth.booth_id)) {
        let index = this.selectedBoothIds.indexOf(booth.booth_id);
        this.selectedBoothIds.splice(index, 1);
      }
    }
  }

  onSave() {
    if (this.dialogData.multible == 0) {
    } else if (
      this.config.selection_type == SINGLE_SELECTION &&
      this.selectedBoothIds.length > 1
    ) {
      this.translate.get("Only one booth can be selected.").subscribe((msg) => {
        this.matSnackBar.open(msg, "Close", {
          panelClass: "snack-danger",
        });
      });
      return;
    }

    var boothFormArray = this.boothList.filter((val: any) =>
      this.selectedBoothIds.includes(val.booth_id)
    );

    this.uiService.showLoading();
    this.dialogRef.close({ data: boothFormArray });
    this.uiService.hideLoading();
  }

  filterCardsByTerm = (searchTerm: string) => {
    this.filterBooths = this.boothList.filter((val: any) => {
      if (searchTerm == "") {
        return true;
      } else {
        if (val.booth.includes(searchTerm)) {
          return true;
        }
        if (val.area.includes(searchTerm)) {
          return true;
        }
        if (val.booth_number.toString().includes(searchTerm)) {
          return true;
        }
      }
    });
  };

  close() {
    this.matDialogRef.close();
  }
}
